import { routeAdjustmentManager } from "@/setup/routes/adjustment.routes";
import { dxtToLocalServerTime, MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MillAdjustmentByShift } from "../models/MillAdjustmentByShift";

type Props = {
	setSelectedId: (id: number | null) => void;
	setShowModal: (show: "new" | "edit" | "delete" | "") => void;
	handleNewAdjustment: () => void;
};

export const useAdjustmentOptionFunctions = ({
	setSelectedId,
	setShowModal,
	handleNewAdjustment,
}: Props) => {
	const navigate = useNavigate();
	const [messageDeleteModal, setMessageDeleteModal] = useState("");

	// Edit
	const editData = (data: MillAdjustmentByShift) => {
		navigate(
			`${routeAdjustmentManager}/${data.ShiftId}?adjustmentId=${data.MillAdjustmentId}`,
		);
		setSelectedId(data.MillAdjustmentId);
		setShowModal("edit");
	};

	// Delete
	const deleteData = (data: MillAdjustmentByShift) => {
		const timestamp = dxtToLocalServerTime(data.Timestamp, "HH:mm:ss");
		setMessageDeleteModal(
			`The adjustment at ${timestamp} will be deleted. Do you want to continue?`,
		);
		navigate(
			`${routeAdjustmentManager}/${data.ShiftId}?adjustmentId=${data.MillAdjustmentId}`,
		);
		setSelectedId(data.MillAdjustmentId);
		setShowModal("delete");
	};

	// Get Menu options
	const getMenuOptions = (data: MillAdjustmentByShift) => {
		let options: MenuOptionType[] = [];

		options.push({
			name: "New Adjustment",
			key: "new_adjustment",
			onClick: () => handleNewAdjustment(),
			icon: <PlaylistAddIcon />,
		});

		if (data) {
			options = options.concat([
				{
					name: "Edit Adjustment",
					key: "edit_adjustment",
					onClick: () => editData(data),
					icon: <Edit />,
				},
				{
					name: "Delete Adjustment",
					key: "delete_adjustment",
					onClick: () => deleteData(data),
					icon: <DeleteIcon />,
				},
			]);
		}

		return options;
	};

	return {
		editData,
		deleteData,
		messageDeleteModal,
		setMessageDeleteModal,
		getMenuOptions,
	};
};
